(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["escvdo-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.escvdoNavReady) return;
    window.escvdoNavReady = true;
    function closeAll(except) {
      document.querySelectorAll('.escvdo-nav__item.is-open').forEach(function (li) {
        if (li === except) return;
        li.classList.remove('is-open');
        var b = li.querySelector('.escvdo-nav__toggle');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest('.escvdo-nav__toggle');
      if (!t) {
        if (!e.target.closest('.escvdo-nav__sub')) closeAll(null);
        return;
      }
      var li = t.closest('.escvdo-nav__item');
      closeAll(li);
      var open = li.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
